export const L10N = {
  ACTION_CHOOSE_ROOM: { id: 'core.action.choose_room' },
  LABEL_CHOOSE_ROOM: { id: 'core.label.choose_room' },
};
